import { render } from "./gmAbnormalCallList.vue?vue&type=template&id=01666b8a&scoped=true"
import script from "./gmAbnormalCallList.vue?vue&type=script&lang=js"
export * from "./gmAbnormalCallList.vue?vue&type=script&lang=js"

import "./gmAbnormalCallList.vue?vue&type=style&index=0&id=01666b8a&scoped=true&lang=css"
import "./gmAbnormalCallList.vue?vue&type=style&index=1&id=01666b8a&lang=css"
script.render = render
script.__scopeId = "data-v-01666b8a"

export default script